<template>
  <section
    v-observe-visibility="isVisible"
    :class="$style.container"
    :style="`background-image:url(${primary.background.url})`"
  >
    <Wrapper :class="$style.inner">
      <div :class="$style.desc">
        <Title :class="$style.title" :title-params="primary.title" />
        <RichText :class="$style.subtitle" :text-params="primary.description" />

        <AddressForm
          :class="$style.inputContainer"
          :placeholder="primary.address_input_placeholder"
          :button-text="primary.cta_title"
          :is-required="false"
        />
      </div>
    </Wrapper>
  </section>
</template>

<script>
import AddressForm from '~/components/AddressForm'
import RichText from '~/components/RichText'
import Title from '~/components/Title'

export default {
  name: 'GivebackHero',

  components: {
    AddressForm,
    RichText,
    Title,
  },

  props: {
    items: {
      type: Array,
      default: null,
    },
    primary: {
      type: Object,
      default: null,
    },
  },
  methods: {
    isVisible(visible) {
      this.$store.commit('header/SET_HEADER_FIXED', !visible)
    },
  },
}
</script>

<style lang="scss" module>
.container {
  max-width: inherit;
  height: 660px;
  margin-top: -64px;
  padding: 0 24px;
  border-top: 64px solid transparent;

  background-color: #fcf7e8;
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: contain;

  @include below(small) {
    background-size: auto 330px;
  }
}

.inner {
  display: flex;

  min-height: 656px;
  padding-top: 88px;

  @include below(medium) {
    min-height: 745px;
    padding-top: 32px;
  }
}

.subtitle {
  max-width: 650px;
  margin: 0;
  padding-bottom: 53px;

  color: $gray-800;
  font-size: $font-size-md;

  p {
    line-height: 32px;
  }

  @include above(large) {
    margin-top: 16px;
  }

  @include below(medium) {
    font-size: 16px;
    line-height: 24px;
  }
}

.title h1 {
  max-width: 725px;

  color: $gray-1000;
  font-weight: 500;
  font-size: 52px;
  line-height: 64px;

  @include below(medium) {
    font-size: 28px;
    line-height: 40px;
  }
}
</style>
